import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="test"
export default class extends Controller {
  initialize() {
    console.log('=== TEST CONTROLLER INITIALIZING ===');
  }

  connect() {
    console.log('=== TEST CONTROLLER CONNECTED ===');
  }
}
